export default {"src":"/_next/static/media/orga-logo.ea0d44b7.svg","height":359,"width":2407,"blurWidth":0,"blurHeight":0};